/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Junior_BodyInputs */

const en_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For players 8–17. Fundamentals, fun, and a long-term plan. Build the swing right, the first time.`)
};

const es_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para jugadores de 8 a 17 años. Fundamentos, diversión y un plan a largo plazo. Construye bien tu swing desde el principio.`)
};

const de_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Spieler von 8 bis 17 Jahren. Grundlagen, Spaß und ein langfristiger Plan. Den Swing von Anfang an richtig aufbauen.`)
};

const zh_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面向 8–17 岁的球员。打好基础、享受乐趣，并制定长期计划。从一开始就把挥杆练对。`)
};

const ar_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`للاعبين من 8 إلى 17 عاماً. الأساسيات والمتعة وخطة طويلة الأمد. ابنِ ضربتك بالشكل الصحيح من البداية.`)
};

const fr_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les joueurs de 8 à 17 ans. Les fondamentaux, du plaisir et un plan à long terme. Un swing bien construit dès le départ.`)
};

const vi_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dành cho người chơi 8–17 tuổi. Nền tảng, niềm vui và kế hoạch dài hạn. Xây swing đúng ngay từ đầu.`)
};

const sw_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa wachezaji wenye umri wa miaka 8–17. Misingi, furaha na mpango wa muda mrefu. Jenga swing sahihi tangu mwanzo.`)
};

const th_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับผู้เล่นอายุ 8–17 ปี พื้นฐาน ความสนุก และแผนระยะยาว สร้างสวิงให้ถูกต้องตั้งแต่แรก`)
};

const bs_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Za igrače od 8 do 17 godina. Osnove, zabava i dugoročni plan. Izgradite pravilan swing od samog početka.`)
};

const ja_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8〜17歳のプレーヤー向け。基礎、楽しさ、そして長期的なプラン。最初から正しいスイングを身につけます。`)
};

const ko_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8~17세 선수를 위한 레슨. 기본기, 재미, 그리고 장기적인 계획. 처음부터 스윙을 올바르게 만듭니다.`)
};

const pt_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para jogadores de 8 a 17 anos. Fundamentos, diversão e um plano de longo prazo. Construa o swing certo desde o início.`)
};

const it_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per giocatori dagli 8 ai 17 anni. Fondamentali, divertimento e un piano a lungo termine. Costruisci lo swing nel modo giusto fin dall’inizio.`)
};

const sv_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För spelare 8–17 år. Grunder, glädje och en långsiktig plan. Bygg svingen rätt från början.`)
};

const nl_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor spelers van 8 tot 17 jaar. De basis, plezier en een plan voor de lange termijn. Bouw de swing meteen goed op.`)
};

const da_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For spillere på 8–17 år. Grundteknik, sjov og en langsigtet plan. Byg svinget rigtigt fra starten.`)
};

const nb_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For spillere fra 8 til 17 år. Grunnleggende teknikk, moro og en langsiktig plan. Bygg svingen riktig fra første stund.`)
};

const fi_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaajille 8–17-vuotiaille. Perustaidot, hauskuus ja pitkän aikavälin suunnitelma. Swing rakennetaan oikein heti alusta.`)
};

const pl_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla zawodników w wieku 8–17 lat. Podstawy, zabawa i długoterminowy plan. Zbuduj prawidłowy swing od samego początku.`)
};

const ru_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для игроков от 8 до 17 лет. Основы, удовольствие от игры и долгосрочный план. Правильный свинг с самого начала.`)
};

const tr_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8–17 yaş arası oyuncular için. Temel beceriler, eğlence ve uzun vadeli bir plan. Swing’i en baştan doğru kurun.`)
};

const hi_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8–17 वर्ष के खिलाड़ियों के लिए। बुनियादी बातें, मज़ा और लंबी अवधि की योजना। पहली बार में ही स्विंग को सही ढंग से तैयार करें।`)
};

const id_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pemain usia 8–17 tahun. Dasar-dasar, keseruan, dan rencana jangka panjang. Bangun ayunan yang benar sejak awal.`)
};

const ms_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pemain berumur 8–17 tahun. Asas, keseronokan dan rancangan jangka panjang. Bina hayunan dengan betul sejak kali pertama.`)
};

const cs_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro hráče od 8 do 17 let. Základy, zábava a dlouhodobý plán. Postavte švih správně hned napoprvé.`)
};

const el_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Για παίκτες 8–17 ετών. Βασικές αρχές, διασκέδαση και μακροπρόθεσμο πλάνο. Χτίστε σωστά το σβινγκ από την αρχή.`)
};

const he_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לשחקנים בני 8–17. יסודות, הנאה ותוכנית ארוכת טווח. בונים את הסווינג נכון כבר מההתחלה.`)
};

const af_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vir spelers van 8 tot 17 jaar. Grondbeginsels, pret en 'n langtermynplan. Bou die swaai van die begin af reg.`)
};

const hu_lessons_format_junior_body = /** @type {(inputs: Lessons_Format_Junior_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8–17 éves játékosoknak. Alapok, szórakozás és hosszú távú terv. Építsd fel helyesen a swinget, már elsőre.`)
};

/**
* | output |
* | --- |
* | "For players 8–17. Fundamentals, fun, and a long-term plan. Build the swing right, the first time." |
*
* @param {Lessons_Format_Junior_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_junior_body = /** @type {((inputs?: Lessons_Format_Junior_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Junior_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_junior_body(inputs)
	if (locale === "de") return de_lessons_format_junior_body(inputs)
	if (locale === "zh") return zh_lessons_format_junior_body(inputs)
	if (locale === "ar") return ar_lessons_format_junior_body(inputs)
	if (locale === "fr") return fr_lessons_format_junior_body(inputs)
	if (locale === "vi") return vi_lessons_format_junior_body(inputs)
	if (locale === "sw") return sw_lessons_format_junior_body(inputs)
	if (locale === "th") return th_lessons_format_junior_body(inputs)
	if (locale === "bs") return bs_lessons_format_junior_body(inputs)
	if (locale === "ja") return ja_lessons_format_junior_body(inputs)
	if (locale === "ko") return ko_lessons_format_junior_body(inputs)
	if (locale === "pt") return pt_lessons_format_junior_body(inputs)
	if (locale === "it") return it_lessons_format_junior_body(inputs)
	if (locale === "sv") return sv_lessons_format_junior_body(inputs)
	if (locale === "nl") return nl_lessons_format_junior_body(inputs)
	if (locale === "da") return da_lessons_format_junior_body(inputs)
	if (locale === "nb") return nb_lessons_format_junior_body(inputs)
	if (locale === "fi") return fi_lessons_format_junior_body(inputs)
	if (locale === "pl") return pl_lessons_format_junior_body(inputs)
	if (locale === "ru") return ru_lessons_format_junior_body(inputs)
	if (locale === "tr") return tr_lessons_format_junior_body(inputs)
	if (locale === "hi") return hi_lessons_format_junior_body(inputs)
	if (locale === "id") return id_lessons_format_junior_body(inputs)
	if (locale === "ms") return ms_lessons_format_junior_body(inputs)
	if (locale === "cs") return cs_lessons_format_junior_body(inputs)
	if (locale === "el") return el_lessons_format_junior_body(inputs)
	if (locale === "he") return he_lessons_format_junior_body(inputs)
	if (locale === "af") return af_lessons_format_junior_body(inputs)
	if (locale === "hu") return hu_lessons_format_junior_body(inputs)
	return en_lessons_format_junior_body(inputs)
});